import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'


Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Extraservices - додаткові послуги на ваших Торгівельних точках',
    }
  },
  {
    path: '/registration',
    name: 'registration',
    meta: {
      title: 'Реєстрацiя :: Extraservices',
    },
    component: () => import('../views/Registration.vue')
  },
  // ---------- АДМІНпанель ----------- //
  {
    path: '/adminpanel',
    name: 'adminpanel',
    meta: {
      title: 'АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanel.vue')
  },
  {
    path: '/adminpanel/users',
    name: 'users',
    meta: {
      title: 'Користувачі :: АДМІНпанель Extraservices ',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelUsers.vue')
  },
  {
    path: '/adminpanel/users/:id',
    name: 'users',
    meta: {
      title: 'Редагування Користувача :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelUsersEdit.vue')
  },
  
  {
    path: '/adminpanel/admins',
    name: 'admins',
    meta: {
      title: 'Адміністратори :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelAdmins.vue')
  },
  {
    path: '/adminpanel/admins/:id',
    name: 'admins',
    meta: {
      title: 'Редагування Адміністратора :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelAdminsEdit.vue')
  },
  {
    path: '/adminpanel/megogo-list',
    name: 'megogo-list',
    meta: {
      title: 'Послуги Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelMegogoList.vue')
  },
  {
    path: '/adminpanel/megogo-service',
    name: 'megogo-service',
    meta: {
      title: 'Сервіс Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelMegogoService.vue')
  },
  {
    path: '/adminpanel/megogo-package-selling',
    name: 'megogo-package-selling',
    meta: {
      title: 'Пакетний продаж Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelMegogoPackageSelling.vue')
  },
  {
    path: '/adminpanel/megogo-package-selling-history',
    name: 'megogo-package-selling-history',
    meta: {
      title: 'Пакетний продаж Megogo історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelMegogoPackageSellingHistory.vue')
  },
  {
    path: '/adminpanel/megogo-package-selling-history/:id',
    name: 'megogo-package-selling-history',
    meta: {
      title: 'Картка Пакетний продаж Megogo історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelMegogoPackageSellingHistoryEdit.vue')
  },

  {
    path: '/adminpanel/youtv-list',
    name: 'youtv-list',
    meta: {
      title: 'Послуги Youtv :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvList.vue')
  },
  {
    path: '/adminpanel/youtv-service',
    name: 'youtv-service',
    meta: {
      title: 'Сервіс Youtv :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvService.vue')
  },
  {
    path: '/adminpanel/youtv-package-selling',
    name: 'youtv-package-selling',
    meta: {
      title: 'Пакетний продаж Youtv :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvPackageSelling.vue')
  },
  {
    path: '/adminpanel/youtv-package-selling-history',
    name: 'youtv-package-selling-history',
    meta: {
      title: 'Пакетний продаж Youtv історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvPackageSellingHistory.vue')
  },
  {
    path: '/adminpanel/youtv-package-selling-history/:id',
    name: 'youtv-package-selling-history',
    meta: {
      title: 'Картка Пакетний продаж Youtv історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvPackageSellingHistoryEdit.vue')
  },
  {
    path: '/adminpanel/youtv-shopping-packet',
    name: 'youtv-shopping-packet',
    meta: {
      title: 'Завантажити коди You TV :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelYoutvShoppingPacket.vue')
  },
   {
    path: '/adminpanel/shopping-packet',
    name: 'shopping-packet',
    meta: {
      title: 'Завантажити коди Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelShoppingPacket.vue')
  },
  // ---------- Подарункові сертифікати ----------- //
    {
    path: '/adminpanel/e-gifts-list',
    name: 'e-gifts-list',
    meta: {
      title: 'Подарункові сертифікати :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsList.vue')
  },

  // Налаштування - e-gifts-service
  // Пакетний продаж Сертифікатів - e-gifts-package-selling
  // Історія пакетного продажу Сертифікатів - e-gifts-package-selling-history
  // Завантажити коди Сертифікатів - e-gifts-shopping-packet
  {
    path: '/adminpanel/e-gifts-service',
    name: 'e-gifts-service',
    meta: {
      title: 'Налаштування Подарункових сертифікатів :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsService.vue')
  },
  { 
    path: '/adminpanel/e-gifts-package-selling',
    name: 'e-gifts-package-selling',
    meta: {
      title: 'Пакетний продаж Подарункових сертифікатів :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsPackageSelling.vue')
  },
  {
    path: '/adminpanel/e-gifts-package-selling-history',
    name: 'e-gifts-package-selling-history',
    meta: {
      title: 'Історія пакетного продажу Подарункових сертифікатів :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsPackageSellingHistory.vue')
  },
  {
    path: '/adminpanel/e-gifts-package-selling-history/:id',
    name: 'e-gifts-package-selling-history',
    meta: {
      title: 'Картка Історія пакетного продажу Подарункових сертифікатів :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsPackageSellingHistoryEdit.vue')
  },
  {
    path: '/adminpanel/e-gifts-shopping-packet',
    name: 'e-gifts-shopping-packet',
    meta: {
      title: 'Завантажити коди Подарункових сертифікатів :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEGiftsShoppingPacket.vue')
  },

  // --------- Епіцентр ----------- //
  {
    path: '/adminpanel/epicentrk-megogo-package-selling-history',
    name: 'epicentrk-megogo-package-selling-history',
    meta: {
      title: 'Пакетний продаж Епіцентр Megogo історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEpicentrkMegogoPackageSellingHistory.vue')
  },
  {
    path: '/adminpanel/epicentrk-megogo-package-selling-history/:id',
    name: 'epicentrk-megogo-package-selling-history',
    meta: {
      title: 'Картка продаж Епіцентр Megogo історія:: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEpicentrkMegogoPackageSellingHistoryEdit.vue')
  },
  {
    path: '/adminpanel/epicentrk-megogo-package-selling',
    name: 'epicentrk-megogo-package-selling',
    meta: {
      title: 'Пакетний продаж Епіцентр Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEpicentrkMegogoPackageSelling.vue')
  },
  {
    path: '/adminpanel/epicentrk-megogo-codes',
    name: 'epicentrk-megogo-codes',
    meta: {
      title: 'Коди Епіцентр Megogo :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEpicentrkMegogoCodes.vue')
  },
  {
    path: '/adminpanel/epicentrk-shopping-packet',
    name: 'epicentrk-shopping-packet',
    meta: {
      title: 'Завантажити коди Megogo Епіцентр :: АДМІНпанель Extraservices',
    },
    component: () => import( /* webpackChunkName: "group-adminpanel" */ '../views/AdminPanelEpicentrkShoppingPacket.vue')
  },

  // --------- You TV ----------- //
  {
    path: '/youtv',
    name: 'youtv',
    component: () => import( /* webpackChunkName: "group-youtv" */ '../views/YouTV.vue'),
    meta: {
      title: 'Послуги YouTV :: Extraservices',
    }
  },
  
  
  // ---------- Megogo ----------- //
  {
    path: '/megogo',
    name: 'megogo',
    component: () => import( /* webpackChunkName: "group-megogo" */ '../views/Megogo.vue'),
    meta: {
      title: 'Послуги Megogo :: Extraservices',
    }
  },
  {
    path: '/megogo/clarification',
    name: 'megogo-clarification',
    meta: {
      title: 'Уточнення даних :: Extraservices',
    },
    component: () => import('../views/MegogoClarification.vue')
  },
  {
    path: '/megogo/instructions',
    name: 'megogo-instructions',
    meta: {
      title: 'Iнструкції :: Extraservices',
    },
    component: () => import('../views/MegogoInstructions.vue')
  },
  {
    path: '/megogo/buy/:id',
    name: 'megogo-buy',
    component: () => import( /* webpackChunkName: "group-megogo" */ '../views/MegogoBuy.vue'),
  },
  // REMOVE THIS AFTER TEST !!! 
  {
    path: '/megogo/success',
    name: 'megogo-success',
    component: () => import('../views/MegogoSuccess.vue')
  },
  {
    path: '/youtv/buy/:id',
    name: 'youtv-buy',
    component: () => import( /* webpackChunkName: "group-megogo" */ '../views/YoutvBuy.vue'),
  },
  // REMOVE THIS AFTER TEST !!! 
  {
    path: '/youtv/success',
    name: 'youtv-success',
    component: () => import('../views/YoutvSuccess.vue')
  },
  {
    path: '/packagesaleinstructions',
    name: 'packagesaleinstructions',
    meta: {
      title: 'Iнструкції :: Extraservices',
    },
    component: () => import('../views/PackageSaleInstructions.vue')
  },

  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Вхiд :: Extraservices',
    },
    component: () => import('../views/Login.vue')
  },

  {
    path: '/403',
    name: '403',
    meta: {
      title: '403',
    },
    component: () => import('../views/Page403.vue')
  },

  // Page Not Foound 404
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '404 :: Extraservices',
    },
    component: () => import('../views/Page404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  
})

//Authorization Checking 
router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  if (to.name != 'login' &&
    to.name != 'registration' &&
    to.name != '404' &&
    to.name != '403') {
    store.dispatch('getUserInfo')
      .then(data => {
        if (data.status === 401) {
          document.title = 'Вхiд'
          next('/login')
        } else {
          // ----- Megogo permitions ------------------------------
          if (to.name == 'megogo' || to.name == 'megogo-buy') {
            if (data.permissions && data.permissions['megogo']) {
              if (data.verifiedUser) {
                next()
              } else {
                next({
                  name: 'megogo-clarification'
                })
              }
            } else {
              document.title = '403'
              next('/403')
            }
          // ----- Admin permitions ------------------------------
          } else if (/^\/adminpanel/.test(to.path)) {
            if (data.adminPermissions && data.adminPermissions[to.name]) {
              next()
            } else {
              document.title = '403'
              next('/403')
            }
          } else {
            next()
          }
        }
      })
      .catch(err => {
        console.log(err)
        next(err)
      })
  } else {
    next()
  }
})

export default router